import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  acceptRejectDomainFailure,
  acceptRejectDomainSuccess,
  deleteUserFailure,
  deleteUserSuccess,
  EditInfluencerUserFailure,
  EditInfluencerUserSuccess,
  geDreamlistFailure,
  geInterstedlistFailure,
  geRelationlistFailure,
  getBloomUserFailure,
  getBloomUserSubscriptionFailure,
  getBloomUserSubscriptionSuccess,
  getBloomUserSuccess,
  getDomainDetailsFailure,
  getDomainDetailsSuccess,
  getDomainInfolistFailure,
  getDomainInfolistSuccess,
  getDreamlistSuccess,
  getEducationlistFailure,
  getEducationlistSuccess,
  getEthnicityFailure,
  getEthnicitylistSuccess,
  getFreeUserFailure,
  getFreeUserSubscriptionFailure,
  getFreeUserSubscriptionSuccess,
  getFreeUserSuccess,
  getHobbieslistFailure,
  getHobbieslistSuccess,
  getInterstedlistSuccess,
  getInviteFriendsFailure,
  getInviteFriendsSuccess,
  getMessageDetailsFailure,
  getMessageDetailsSuccess,
  getMessagelistFailure,
  getMessagelistSuccess,
  getMySelflistFailure,
  getMySelflistSuccess,
  getPremiumUserFailure,
  getPremiumUserSubscriptionFailure,
  getPremiumUserSubscriptionSuccess,
  getPremiumUserSuccess,
  getQueryDetailsFailure,
  getQueryDetailsSuccess,
  getQueryUserlistFailure,
  getQueryUserlistSuccess,
  getRelationlistSuccess,
  getReligionlistFailure,
  getReligionlistSuccess,
  getSubscriptionDetailsFailure,
  getSubscriptionDetailsSuccess,
  getSubUserlistFailure,
  getSubUserlistSuccess,
  getUserlistFailure,
  getUserlistSuccess,
  getUsersFeedbackFailure,
  getUsersFeedbackSuccess,
  openCloseSupportFailure,
  openCloseSupportSuccess,
  resumeSuspendUserFailure,
  resumeSuspendUserSuccess,
  sendAdminMessageResponseFailure,
  sendAdminMessageResponseSuccess,
  sendAdminQueryResponseFailure,
  sendAdminQueryResponseSuccess,
} from '../../Redux/Actions/DashboardAction';
import {
  ACCEPT_REJECT_DOMAIN,
  DELETE_USER,
  EDIT_INFLUENCER_USER,
  GET_BLOOM_USER_LIST,
  GET_BLOOMSUB_USER_LIST,
  GET_DOMAIN_DETAILS,
  GET_DOMAIN_INFO_LIST,
  GET_DREAM_LIST,
  GET_EDUCATION_LIST,
  GET_ETHNICITY_LIST,
  GET_FREE_USER_LIST,
  GET_FREESUB_USER_LIST,
  GET_HOBBIES_LIST,
  GET_INTRESTED_LIST,
  GET_INVITE_FRIENDS_LIST,
  GET_MESSAGE_DETAILS,
  GET_MESSAGE_LIST,
  GET_MYSELF_LIST,
  GET_PREMIUM_USER_LIST,
  GET_PREMIUMSUB_USER_LIST,
  GET_QUERY_DETAILS,
  GET_QUERY_USER_LIST,
  GET_RELATION_LIST,
  GET_RELIGION_LIST,
  GET_SUB_USER_LIST,
  GET_SUBSCRIPTION_DETAILS,
  GET_USER_LIST,
  GET_USERS_FEEDBACK_LIST,
  OPEN_CLOSE_SUPPORT,
  RESUME_SUSPEND_USER,
  SEND_ADMIN_MESSAGE_RESPONSE,
  SEND_ADMIN_QUERY_RESPONSE,
} from '../../Redux/Actiontype';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const FreeSubEpic = action$ =>
  action$.pipe(
    ofType(GET_FREESUB_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getFreeUserSubscription?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            console.log('action.payload', action.payload);
            if (response.response.statusCode === 200) {
              return of(getFreeUserSubscriptionSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getFreeUserSubscriptionFailure(response.response));
            }
          }),
        ),
    ),
  );

export const FreeUserEpic = action$ =>
  action$.pipe(
    ofType(GET_FREE_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getFreeUser`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getFreeUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getFreeUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const BloomSubEpic = action$ =>
  action$.pipe(
    ofType(GET_BLOOMSUB_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getBloomUserSubscription?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            console.log('action.payload', action.payload);
            if (response.response.statusCode === 200) {
              return of(getBloomUserSubscriptionSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getBloomUserSubscriptionFailure(response.response));
            }
          }),
        ),
    ),
  );

export const BloomEpic = action$ =>
  action$.pipe(
    ofType(GET_BLOOM_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getBloomUser?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getBloomUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getBloomUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const PermiumSubEpic = action$ =>
  action$.pipe(
    ofType(GET_PREMIUMSUB_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getPremiumUserSubscription?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            console.log('action.payload', action.payload);
            if (response.response.statusCode === 200) {
              return of(getPremiumUserSubscriptionSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getPremiumUserSubscriptionFailure(response.response));
            }
          }),
        ),
    ),
  );

export const PermiumEpic = action$ =>
  action$.pipe(
    ofType(GET_PREMIUM_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getPremiumUser?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getPremiumUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getPremiumUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const ReligionEpic = action$ =>
  action$.pipe(
    ofType(GET_RELIGION_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getReligion`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getReligionlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getReligionlistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const EducationEpic = action$ =>
  action$.pipe(
    ofType(GET_EDUCATION_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getEducation`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getEducationlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getEducationlistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const MySelfEpic = action$ =>
  action$.pipe(
    ofType(GET_MYSELF_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getMySelf`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getMySelflistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getMySelflistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const HobbiesEpic = action$ =>
  action$.pipe(
    ofType(GET_HOBBIES_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getHobbies`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getHobbieslistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getHobbieslistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const InterstedeEpic = action$ =>
  action$.pipe(
    ofType(GET_INTRESTED_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getInterested`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getInterstedlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(geInterstedlistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const RelationEpic = action$ =>
  action$.pipe(
    ofType(GET_RELATION_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getRelationship`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getRelationlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(geRelationlistFailure(response.response));
            }
          }),
        ),
    ),
  );
export const DreamEpic = action$ =>
  action$.pipe(
    ofType(GET_DREAM_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getMyDream`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getDreamlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(geDreamlistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const DashboardEpic = action$ =>
  action$.pipe(
    ofType(GET_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/userList?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              response.response.filter = action.payload;
              return of(getUserlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getUserlistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetQueryDetailsEpic = action$ =>
  action$.pipe(
    ofType(GET_QUERY_DETAILS),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getQueryDetails?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getQueryDetailsSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getQueryDetailsFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetMessageDetailsEpic = action$ =>
  action$.pipe(
    ofType(GET_MESSAGE_DETAILS),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getMessageDetails?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getMessageDetailsSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getMessageDetailsFailure(response.response));
            }
          }),
        ),
    ),
  );

export const SendAdminQueryResponseEpic = action$ =>
  action$.pipe(
    ofType(SEND_ADMIN_QUERY_RESPONSE),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/sendAdminQueryResponse`, action.payload, {
          'Content-Type': 'application/json',
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(sendAdminQueryResponseSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(sendAdminQueryResponseFailure(response.response));
            }
          }),
        ),
    ),
  );

export const SendAdminMessageResponseEpic = action$ =>
  action$.pipe(
    ofType(SEND_ADMIN_MESSAGE_RESPONSE),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/sendAdminMessageResponse`, action.payload, {
          'Content-Type': 'application/json',
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(sendAdminMessageResponseSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(sendAdminMessageResponseFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetSubUserEpic = action$ =>
  action$.pipe(
    ofType(GET_SUB_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getReportedUserList`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getSubUserlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getSubUserlistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetUsersFeedbackEpic = action$ =>
  action$.pipe(
    ofType(GET_USERS_FEEDBACK_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/v1/admin/actions/appRating`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            console.log('users feedback response', response.response.data);
            if (response.response.data.statusCode === 200) {
              return of(getUsersFeedbackSuccess(response.response.data));
            } else if (response.response.data.statusCode == 401) {
              clearSession(response.response.data.message);
            } else {
              return of(getUsersFeedbackFailure(response.response.data));
            }
          }),
        ),
    ),
  );

export const GetFriendsInvitationsEpic = action$ =>
  action$.pipe(
    ofType(GET_INVITE_FRIENDS_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/v1/admin/actions/inviteFriend`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            console.log('invite friends response', response.response.data);
            if (response.response.data.statusCode === 200) {
              return of(getInviteFriendsSuccess(response.response.data));
            } else if (response.response.data.statusCode == 401) {
              clearSession(response.response.data.message);
            } else {
              return of(getInviteFriendsFailure(response.response.data));
            }
          }),
        ),
    ),
  );

export const GetEthnicityUserEpic = action$ =>
  action$.pipe(
    ofType(GET_ETHNICITY_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/user/getEthnicity`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getEthnicitylistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getEthnicityFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetQueryUserEpic = action$ =>
  action$.pipe(
    ofType(GET_QUERY_USER_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getQueryUserList?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getQueryUserlistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getQueryUserlistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetMessageListEpic = action$ =>
  action$.pipe(
    ofType(GET_MESSAGE_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getAdminMessage`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getMessagelistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getMessagelistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const SubscriptionEpic = action$ =>
  action$.pipe(
    ofType(GET_SUBSCRIPTION_DETAILS),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/getSubscriptionInfo`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getSubscriptionDetailsSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getSubscriptionDetailsFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetDomainDetailsEpic = action$ =>
  action$.pipe(
    ofType(GET_DOMAIN_DETAILS),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/getInfluencerDetails?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getDomainDetailsSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getDomainDetailsFailure(response.response));
            }
          }),
        ),
    ),
  );

export const EditInfluencerUserEpic = action$ =>
  action$.pipe(
    ofType(EDIT_INFLUENCER_USER),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editInfluencerUser`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditInfluencerUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditInfluencerUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const DeleteUserEpic = action$ =>
  action$.pipe(
    ofType(DELETE_USER),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/deleteUser`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(deleteUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(deleteUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const GetDomainInfoListEpic = action$ =>
  action$.pipe(
    ofType(GET_DOMAIN_INFO_LIST),
    switchMap(action =>
      ajax
        .get(`${Basepath}/api/admin/InfluencerUser?${action.payload}`, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(getDomainInfolistSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(getDomainInfolistFailure(response.response));
            }
          }),
        ),
    ),
  );

export const AcceptRejectDomainEpic = action$ =>
  action$.pipe(
    ofType(ACCEPT_REJECT_DOMAIN),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/InfluencerUserAcceptAndDecline`, action.payload, {
          'Content-Type': 'application/json',
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              // history.push(routeRules.dashboard, toast.success(response.response.Message))
              return of(acceptRejectDomainSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(acceptRejectDomainFailure(response.response));
            }
          }),
        ),
    ),
  );

export const ResumeSuspendUserEpic = action$ =>
  action$.pipe(
    ofType(RESUME_SUSPEND_USER),
    switchMap(action =>
      ajax
        .put(
          `${Basepath}/api/v1/admin/actions/suspendUser?${action.payload}`,
          {},
          {
            authentication: localStorage.getItem('sessionId'),
          },
        )
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(resumeSuspendUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(resumeSuspendUserFailure(response.response));
            }
          }),
        ),
    ),
  );

export const OpenCloseSupportEpic = action$ =>
  action$.pipe(
    ofType(OPEN_CLOSE_SUPPORT),
    switchMap(action =>
      ajax
        .put(
          `${Basepath}/api/admin/closeSupport?${action.payload}`,
          {},
          {
            authentication: localStorage.getItem('sessionId'),
          },
        )
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(openCloseSupportSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(openCloseSupportFailure(response.response));
            }
          }),
        ),
    ),
  );

export const DeleteContentEpic = action$ =>
  action$.pipe(
    ofType(DELETE_USER),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/DeleteContent`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(deleteUserSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(deleteUserFailure(response.response));
            }
          }),
        ),
    ),
  );
